import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import Draggable from "react-draggable";
import { Col, Form } from "react-bootstrap";
import { packagesServices } from "../../../../APIServices/Editor/packagesServices";

const UpdatePackageLibraryDataModal = ({
  show,
  title,
  bounds,
  submit,
  setShow,
  onStart,
  disabled,
  draggleRef,
  onMouseOut,
  onMouseOver,
  packagesPropertiesData,
  openPackageFileById,
  packageFileType,
  getTempLibraryFolderData
}) => {
  const [editTitle, setEditTitle] = useState("");
  const [updateDescription, setUpdateDescription] = useState("");
  const [error, setError] = useState("");
  const updateLibraryFolderData = async () => {
    let userData = {};
    userData.id = packagesPropertiesData?._id;
    userData.name = editTitle;
    userData.description = updateDescription;
    let data = await packagesServices.updateLibraryFolderData(userData);
    if (data?.statusCode === 200) {
      setShow();
      openPackageFileById(packageFileType);
      getTempLibraryFolderData()
    }
  };

  const validateFileTitle = (input) => {
    const fileTitleRegex = /^[a-zA-Z0-9_]+$/;

    if (!fileTitleRegex.test(input)) {
      setError(
        "File Title should only contain capital letters, small letters, or numbers"
      );
    } else {
      setError("");
    }
  };

  useEffect(() => {
    setEditTitle(packagesPropertiesData?.name);
    setUpdateDescription(packagesPropertiesData?.description);
  }, [packagesPropertiesData]);
  return (
    <>
      <Modal
        title={
          <div
            className="modal_Heading"
            onMouseOver={() => {
              if (disabled) {
                onMouseOver();
              }
            }}
            onMouseOut={onMouseOut}
          >
            <h5>{title}</h5>
          </div>
        }
        width={400}
        open={show}
        onOk={() => setShow(!show)}
        onCancel={() => setShow(!show)}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            nodeRef={draggleRef}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        <div className="common_css table_content">
          <Form.Group as={Col} md="12">
            <Form.Label>
              File Name <span>*</span>
            </Form.Label>
            <Form.Control
              required
              type="text"
              onChange={(e) => {
                setEditTitle(e.target.value);
                validateFileTitle(e.target.value);
              }}
              value={editTitle}
              placeholder="Enter File Name"
              style={{ fontSize: 13 }}
            />
            {error && (
              <span
                style={{ fontSize: 10, color: "red", fontWeight: 600 }}
              >
                Folder Name Title should only contain capital letters,
                small letters, underScore, and numbers "Space Not Allowed"
                <br />
              </span>
            )}
          </Form.Group>
          <Form.Group as={Col} md="12" className="my-3">
            <Form.Label>
              Description <span>*</span>
            </Form.Label>
            <Form.Control
              required
              as="textarea"
              onChange={(e) => setUpdateDescription(e.target.value)}
              value={updateDescription}
              placeholder="Enter Description"
              style={{ fontSize: 13 }}
            />
          </Form.Group>
        </div>
        <div className="button_type footer_btn text-end px-3 pt-2">
          <button
            onClick={updateLibraryFolderData}
            disabled={!editTitle || !updateDescription}
          >
            {submit}
          </button>
        </div>
      </Modal>
    </>
  );
};
export default UpdatePackageLibraryDataModal;
